<template>
  <el-card class="card filterResourceCard">
    <div slot="header">
      <strong class="filterResourceCard__title">过滤条件</strong>
    </div>
    <div>
      <el-form-item label="国家（选填）">
        <el-radio-group
          v-model="country.isExclude"
          size="small"
          class="filterResourceCard__countryMode"
        >
          <el-radio-button :label="false">包含所选国家</el-radio-button>
          <el-radio-button :label="true">排除所选国家</el-radio-button>
        </el-radio-group>
        <div class="filterResourceCard__countrySelect">
          <el-select
            v-model="country.countries"
            multiple
            filterable
            collapse-tags
            popper-class="genericResourceDropdown"
            placeholder="请选择国家"
          >
            <el-option
              v-for="item in countryOption"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </el-form-item>

      <!-- Android / iOS 系统版本并排：与「应用版本」等多行字段区分，减少纵向占用 -->
      <div class="filterResourceCard__osVersionPair">
        <el-form-item
          label="Android 系统版本（选填）"
          class="filterResourceCard__osVersionCol"
        >
          <div class="filterResourceCard__versionRow">
            <el-input
              placeholder="开始"
              class="filterResourceCard__versionInput"
              type="number"
              v-model.number="androidBeginVersionCopy"
              @change="inputChange('androidBeginVersion', 'androidBeginVersionCopy')"
            />
            <span class="filterResourceCard__versionDash">-</span>
            <el-input
              placeholder="结束"
              type="number"
              class="filterResourceCard__versionInput"
              v-model.number="androidOverVersionCopy"
              @change="inputChange('androidOverVersion', 'androidOverVersionCopy')"
            />
            <el-input
              placeholder="跳过版本，逗号分隔"
              class="filterResourceCard__skipInput filterResourceCard__skipInput--os"
              v-model="androidNeglectVersionCopy"
              @change="inputChange('androidNeglectVersion', 'androidNeglectVersionCopy')"
            />
          </div>
        </el-form-item>

        <el-form-item
          label="iOS 系统版本（选填）"
          class="filterResourceCard__osVersionCol"
        >
          <div class="filterResourceCard__versionRow">
            <el-input
              placeholder="开始"
              class="filterResourceCard__versionInput"
              type="number"
              v-model.number="iosBeginVersionCopy"
              @change="inputChange('iosBeginVersion', 'iosBeginVersionCopy')"
            />
            <span class="filterResourceCard__versionDash">-</span>
            <el-input
              placeholder="结束"
              type="number"
              class="filterResourceCard__versionInput"
              v-model.number="iosOverVersionCopy"
              @change="inputChange('iosOverVersion', 'iosOverVersionCopy')"
            />
            <el-input
              placeholder="跳过版本，逗号分隔"
              class="filterResourceCard__skipInput filterResourceCard__skipInput--os"
              v-model="iosNeglectVersionCopy"
              @change="inputChange('iosNeglectVersion', 'iosNeglectVersionCopy')"
            />
          </div>
        </el-form-item>
      </div>

      <el-form-item label="应用版本（选填）">
        <div
          v-for="(item, index) in appVersion"
          :key="item._rowId"
          class="filterResourceCard__appVersionRow"
        >
          <el-input
            placeholder="开始"
            type="number"
            class="filterResourceCard__versionInput"
            v-model.number="item.start"
          />
          <span class="filterResourceCard__versionDash">-</span>
          <el-input
            placeholder="结束"
            type="number"
            class="filterResourceCard__versionInput"
            v-model.number="item.end"
          />
          <el-input
            placeholder="跳过版本，逗号分隔"
            class="filterResourceCard__skipInput"
            v-model="item.skip"
          />
          <el-select
            v-model="item.dataSetId"
            class="filterResourceCard__dataSetSelect"
            popper-class="genericResourceDropdown"
            placeholder="请选择数据集"
            filterable
            clearable
          >
            <el-option
              v-for="opt in dataOptions"
              :key="opt.id"
              :label="opt.name"
              :value="opt.id"
            />
          </el-select>
          <button
            v-show="appVersion.length > 1 && !disabled"
            type="button"
            class="filterResourceCard__iconBtn filterResourceCard__iconBtn--remove"
            aria-label="删除此行"
            @click="deleteAppVersion(index)"
          >
            <i class="el-icon-remove-outline" />
          </button>
          <button
            v-show="appVersion.length - 1 === index && !disabled"
            type="button"
            class="filterResourceCard__iconBtn filterResourceCard__iconBtn--add"
            aria-label="添加一行"
            @click="addAppVersion"
          >
            <i class="el-icon-circle-plus-outline" />
          </button>
        </div>
      </el-form-item>
    </div>
  </el-card>
</template>

<script>
import { getCountry } from '../api/comment'

export default {
  name: 'filterResourceCard',
  props: {
    country: Object,
    androidBeginVersion: Number | String,
    androidOverVersion: Number | String,
    androidNeglectVersion: String | Array,
    iosBeginVersion: Number | String,
    iosOverVersion: Number | String,
    iosNeglectVersion: String | Array,
    appVersion: Object | Array,
    dataOptions: Array,
    disabled: Boolean
  },
  data() {
    return {
      androidBeginVersionCopy: this.androidBeginVersion,
      androidOverVersionCopy: this.androidOverVersion,
      androidNeglectVersionCopy: this.androidNeglectVersion,
      iosBeginVersionCopy: this.iosBeginVersion,
      iosOverVersionCopy: this.iosOverVersion,
      iosNeglectVersionCopy: this.iosNeglectVersion,
      countryOption: []
    }
  },
  watch: {
    // 父级异步加载后才写入 appVersion；仅 created 调会漏补 _rowId，导致 :key 回退 index
    appVersion: {
      immediate: true,
      handler() {
        this.ensureAppVersionRowIds()
      },
    },
  },
  created() {
    this.getCountryList()
  },
  methods: {
    /**
     * 为应用版本行补稳定 _rowId，避免删除中间行时 Vue 复用 DOM 导致输入错位。
     */
    ensureAppVersionRowIds() {
      if (!Array.isArray(this.appVersion)) {
        return
      }
      this.appVersion.forEach((item) => {
        if (item && !item._rowId) {
          this.$set(item, '_rowId', this.createAppVersionRowId())
        }
      })
    },
    createAppVersionRowId() {
      return `app-ver-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
    },
    getCountryList() {
      getCountry().then((res) => {
        if (res.success) {
          this.countryOption = res.data
        }
      })
    },
    deleteAppVersion(index) {
      this.appVersion.splice(index, 1)
    },
    addAppVersion() {
      this.appVersion.push({
        _rowId: this.createAppVersionRowId(),
        start: '',
        end: '',
        skip: '',
        dataSetId: ''
      })
    },
    inputChange(emitName, value = '') {
      this.$emit(`update:${emitName}`, this[value ? value : emitName])
    }
  }
}
</script>

<style scoped>
.filterResourceCard__title {
  font-size: 14px;
}

.filterResourceCard__countryMode {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.filterResourceCard__countrySelect {
  max-width: 480px;
}

/* 系统版本双列：窄屏自动折行，避免挤压应用版本区块 */
.filterResourceCard__osVersionPair {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 16px 24px;
  margin-bottom: 18px;
}

.filterResourceCard__osVersionCol {
  flex: 1 1 280px;
  min-width: 0;
  margin-bottom: 0;
}

.filterResourceCard__versionRow,
.filterResourceCard__appVersionRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.filterResourceCard__appVersionRow {
  margin-bottom: 10px;
}

.filterResourceCard__appVersionRow:last-child {
  margin-bottom: 0;
}

.filterResourceCard__versionInput {
  width: 88px;
  flex-shrink: 0;
}

.filterResourceCard__skipInput {
  width: 200px;
  flex-shrink: 0;
}

.filterResourceCard__skipInput--os {
  flex: 1 1 120px;
  width: auto;
  min-width: 120px;
}

.filterResourceCard__dataSetSelect {
  width: 220px;
  flex-shrink: 0;
}

.filterResourceCard__versionDash {
  color: var(--link-ink-muted, #a8a29e);
  user-select: none;
}

.filterResourceCard__iconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: 8px;
  background: var(--link-field-bg, #f3f0ea);
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.filterResourceCard__iconBtn--add {
  color: var(--link-accent, #2563eb);
}

.filterResourceCard__iconBtn--add:hover {
  background: var(--link-accent-bg, #f0f7ff);
  border-color: var(--link-accent-border, #cce5ff);
}

.filterResourceCard__iconBtn--remove {
  color: var(--link-status-danger-ink, #dc2626);
}

.filterResourceCard__iconBtn--remove:hover {
  background: var(--link-status-error-bg, #fef2f2);
  border-color: var(--link-status-error-border, #fecaca);
}

.filterResourceCard__iconBtn i {
  font-size: 16px;
}
</style>
